module.exports = __webpack_public_path__ + "img/icon-phone.fef1a09a.svg";